import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Modal,
} from "react-bootstrap";

import api from "../../services/api";
import * as S from "./styled";
import { useAuth } from "../../context/auth";
import Template from "../../template";

function Classes() {
 
  const [classes, setClasses] = useState([]);
  /* Começa carregando: a busca dispara no primeiro efeito, e sem isso a tela
     mostraria "nenhuma turma" por um instante antes dos dados chegarem. */
  const [carregando, setCarregando] = useState(true);

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [description, setDescription] = useState("");

  const [reload, setReload] = useState("");
  const [showArchived, setShowArchived] = useState(false); // alterna entre classes ativas e arquivadas

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { user }  = useAuth();

  useEffect(() => {
    if (!user?.nivel) return;

    const role =
      user.nivel === "a" ? "ADM" :
      user.nivel === "c" ? "CORRETOR" :
      user.nivel === "e" ? "ESTUDANTE" :
      user.nivel === "t" ? "TESTE" :
      `DESCONHECIDO (${user.nivel})`;

    console.log(`%cTipo de usuário: ${role}`, 'color: white; background-color: darkblue; padding: 2px 5px; border-radius: 2px;');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // roda só 1 vez



  async function handleAddClasse(e) {
    e.preventDefault();

    const dataClasse = {
      name: name,
      type: type,
      description: description,
    };

    let response = await api.post("/classes", dataClasse);

    handleClose();

    setName("");
    setType("");
    setDescription("");

    setReload(response.data);
  }

  // Função para arquivar uma turma
  async function handleArchiveClass(classId) {
    try {
      await api.post("/arquivarTurma", { turma_id: classId });
      setReload(Date.now()); // Força reload das turmas
    } catch (err) {
      console.error("Erro ao arquivar turma:", err);
    }
  }

  // Função para desarquivar uma turma
  async function handleUnarchiveClass(classId) {
    try {
      await api.post("/desarquivarTurma", { turma_id: classId });
      setReload(Date.now()); // Força reload das turmas
    } catch (err) {
      console.error("Erro ao desarquivar turma:", err);
    }
  }

  useEffect(() => {
    async function getClasses() {

      /* debug logs detalhados para entender o fluxo e os dados envolvidos
      console.log('🏫 === DEBUG getClasses ===');
      console.log('👤 User object:', user);
      console.log('🔑 User nivel:', user?.nivel);
      console.log('📁 Show archived:', showArchived);
      */
      
      setCarregando(true);

      try {
        let response;
        
        // Se for admin, pode alternar entre ativas e arquivadas
        if (user.nivel === "a") {
          // console.log('usuário é admin');
          if (showArchived) {
            // console.log('📦 Buscando turmas ARQUIVADAS...');
            response = await api.get("/getTurmasArquivadas");
            // console.log('📦 Resposta turmas arquivadas:', response);
          } else {
            // console.log('✅ Buscando turmas ATIVAS...');
            response = await api.get("/getTurmas");
            // console.log('✅ Resposta turmas ativas:', response);
          }
        } else {
          // console.log(' usuario é aluno/professor');
          // Para alunos, buscar todas as turmas (ativas + arquivadas)
          try {
            // console.log('buscando turmas ativas para aluno...');
            // Primeiro tenta buscar turmas ativas
            const activeTurmasResponse = await api.get("/getTurmas").catch(() => ({ data: [] }));
            // console.log('turmas ativas response:', activeTurmasResponse);
            
            // console.log('buscando turmas arquivadas para aluno...');
            // Depois tenta buscar turmas arquivadas
            const archivedTurmasResponse = await api.get("/getTurmasArquivadas").catch(() => ({ data: [] }));
            // console.log('turmas arquivadas response:', archivedTurmasResponse);
            
            // Combinar turmas ativas e arquivadas para o aluno
            const allTurmas = [
              ...(activeTurmasResponse.data || []),
              ...(archivedTurmasResponse.data || [])
            ];
            
            // console.log('turmas combinadas:', allTurmas);
            response = { data: allTurmas };
          } catch (err) {
            console.log('Erro ao buscar turmas combinadas:', err);
            // se tudo falhar, tentar pelo menos as turmas ativas
            try {
              //console.log('tentando apenas turmas ativas como fallback...');
              response = await api.get("/getTurmas");
              // console.log('fallback turmas ativas:', response);
            } catch (finalErr) {
              console.log('Erro final, retornando array vazio:', finalErr);
              // Se nem as turmas ativas funcionarem, retorna array vazio
              response = { data: [] };
            }
          }
        }

        // console.log('📊 Response final:', response);
        // console.log('📊 Response data:', response.data);
        if (response.data?.length) {
          console.log('%cQuantidade de turmas: ' + response.data.length, "color: white; background-color: darkblue; padding: 2px 5px; border-radius: 2px;");
        }

       
        /*
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach((turma, index) => {
            console.log(`🏫 Turma ${index + 1}:`, {
              id: turma.id,
              name: turma.name,
              type: turma.type,
              description: turma.description,
              archived: turma.archived
            });
          });
        }
        */

        setClasses(response.data);
        // console.log('classes setadas no state');
      } catch (err) {
        console.error("❌ Erro ao carregar turmas:", err);
        console.error("❌ Error response:", err.response);
        console.error("❌ Error status:", err.response?.status);
        console.error("❌ Error data:", err.response?.data);
      } finally {
        setCarregando(false);
      }
    }

    if (user && user.nivel) {
      // console.log('iniciando getClasses...');
      getClasses();
    } else {
      /* Sem user ainda: continua em carregamento, não é lista vazia. */
      setCarregando(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, showArchived, user.nivel]);

  return (
    <Template>
    <S.MainWrapper>
      <Container fluid>
        <Row>
          <Col sm={12}>
            {user.nivel === "a" && (
              <>
                <S.MainContent>
                  <strong>Administração</strong>
                  <Button
                    className="pull-right"
                    variant="success"
                    size="sm"
                    onClick={handleShow}
                  >
                    Adicionar Classe
                  </Button>

                  <Modal show={show} onHide={handleClose}>
                    <Modal.Header closeButton>
                      <Modal.Title>Adicionar Classe</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Form>
                        <Form.Label>Nome da Classe</Form.Label>
                        <Form.Control
                          placeholder="Nome da Classe"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <hr />

                        <Form.Control
                          onChange={(e) => setType(e.target.value)}
                          as="select"
                          custom
                        >
                          <option value="Selecione o tipo da Classe">
                            Selecione o tipo da Classe
                          </option>
                          <option value="Presencial">Presencial</option>
                          <option value="Internet">Internet</option>
                          <option value="Somente IA">Somente IA</option>
                          <option value="UERJ">UERJ</option>
                        </Form.Control>



                        <hr />
                        <Form.Control
                          placeholder="Descrição da Classe"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        />
                        <hr />
                      </Form>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                      </Button>
                      <Button variant="primary" onClick={handleAddClasse}>
                        Adicionar
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </S.MainContent>


              </>
            )}

            <S.MainContent>
              <Row>
                <Col>
                  <legend>
                    <strong>Minha(s) Classe(s)</strong>
                  </legend>
                </Col>
              </Row>

              {/* Botão para alternar entre visualizar classes ativas e arquivadas - apenas para admin */}
              {user.nivel === "a" && (
                <Row>
                  <Col sm={12} style={{ marginBottom: "1rem" }}>
                    <Button
                      onClick={() => setShowArchived(!showArchived)}
                      variant="info"
                    >
                      {showArchived
                        ? "Mostrar Classes Ativas"
                        : "Mostrar Classes Arquivadas"}
                    </Button>
                  </Col>
                </Row>
              )}

              {carregando && (
                <S.AvisoCarregando>
                  <span className="roda" />
                  Carregando turmas...
                </S.AvisoCarregando>
              )}

              <Row>
                {carregando &&
                  [0, 1, 2, 3].map((i) => (
                    <Col sm={3} key={`esqueleto-${i}`}>
                      <S.CardEsqueleto>
                        <div className="barra titulo" />
                        <div className="barra linha" />
                        <div className="barra curta" />
                        <div className="barra botao" />
                      </S.CardEsqueleto>
                    </Col>
                  ))}

                {!carregando && classes && classes.length === 0 && (
                  <Col sm={12}>
                    <S.ListaVazia>
                      <i className="fas fa-chalkboard" />
                      <strong>
                        {showArchived ? "Nenhuma turma arquivada" : "Nenhuma turma encontrada"}
                      </strong>
                      <span>
                        {showArchived
                          ? "As turmas que você arquivar aparecem aqui."
                          : "Cadastre uma turma para começar."}
                      </span>
                    </S.ListaVazia>
                  </Col>
                )}

                {!carregando &&
                  classes &&
                  classes.map((classe, idx) => (
                    <Col sm={3} key={classe.id}>
                      <Card>
                        <Card.Header>{classe.type}</Card.Header>
                        <Card.Body>
                          <Card.Title>{classe.name}</Card.Title>
                          <Card.Text>{classe.description}</Card.Text>
                          {user.nivel === "a" ? (
                            <Row>
                              <Col xs={6}>
                                <Link
                                  className="btn btn-primary btn-block"
                                  to={`/minhaclasse/${classe.id}`}
                                >
                                  Visualizar
                                </Link>
                              </Col>
                              <Col xs={6}>
                                <Button
                                  className="btn-block"
                                  variant={showArchived ? "warning" : "secondary"}
                                  onClick={() =>
                                    showArchived
                                      ? handleUnarchiveClass(classe.id)
                                      : handleArchiveClass(classe.id)
                                  }
                                >
                                  {showArchived ? "Desarquivar" : "Arquivar"}
                                </Button>
                              </Col>
                            </Row>
                          ) : (
                            <Link
                              className="btn btn-primary"
                              to={`/minhaclasse/${classe.id}`}
                            >
                              Visualizar
                            </Link>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
              </Row>
            </S.MainContent>
          </Col>
        </Row>
      </Container>
    </S.MainWrapper>
    </Template>
  );
}

export default Classes;
